// VehicleInfo.js - Main Container Component
import React, { useEffect, useState } from "react";

import "./VehicleInfo.scss";
import VehicleModal from "./VehicleModal";
import VehicleTable from "./VehicleTable";
import DeleteModal from "./DeleteModal";
import axios from "axios";

const VehicleInfo = () => {

  const [vehiclesData, setVehiclesData] = useState([])

    const token = localStorage.getItem("customer-token");
 
    const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;


        const fetchVehicle = async () => {
            try {
                const response = await axios.get(
                    `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setVehiclesData(response?.data?.data)
            } catch (error) {
                console.error("Error fetching profile:", error);
            }
        };

        console.log(vehiclesData, "vehiclesData")

      useEffect(() => {

        fetchVehicle();
    }, []);


  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editingVehicle, setEditingVehicle] = useState(null);
  const [deletingVehicleData, setDeletingVehicleData] = useState(null);

  const handleEdit = (vehicle) => {
    // const vehicle = vehicles.find((v) => v.id === id);
    setEditingVehicle(vehicle);
    setShowModal(true);
  };

  const handleDelete = (vehicle) => {

    console.log(vehicle, "vehicleDelete")
    setDeletingVehicleData(vehicle?.id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async() => {
    
            try {
                const response = await axios.delete(
                    `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/${deletingVehicleData}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response?.data) {
                  fetchVehicle()
                  
                }
                // setVehiclesData(response?.data?.data)
            } catch (error) {
                console.error("Error fetching profile:", error);
            }
        
    if (deletingVehicleData) {
      setVehiclesData((prev) =>
        prev.filter((vehicle) => vehicle?.data?.data.id !== deletingVehicleData)
      );
      setShowDeleteModal(false);
      setDeletingVehicleData(null);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    // deletingVehicleData(null);
  };

  const handleAddVehicle = () => {
    setEditingVehicle(null);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingVehicle(null);
  };

  return (
    <div className="customer-vehicle-info">
      <div className="customer-vehicle-info__header">
        {/* <h1 className="vehicle-info__title">Welcome Vineet Singh</h1> */}
        <button style={{borderRadius: "20px"}} className="customer-vehicle-info__add-btn" onClick={handleAddVehicle}>
          Add Vehicle
        </button>
      </div>

      {/* <VehicleTable
        vehicles={vehiclesData}
        onEdit={handleEdit}
        onDelete={handleDelete}

      /> */}

      {showModal && (
        <VehicleModal
          vehicle={editingVehicle}
          // onSave={handleSaveVehicle}
          onClose={handleCloseModal}
          fetchVehicle={fetchVehicle}
      

          
        />
      )}

      {showDeleteModal && (
        <DeleteModal
          message="Are you sure you want to delete this vehicle? This action cannot be undone."
          onConfirm={confirmDelete}
          onCancel={cancelDelete}
          handleCloseModal={handleCloseModal}
        />
      )}
    </div>
  );
};

export default VehicleInfo;